/** 
 * Copyright (c) Open Carbon, 2020
 * 
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * constants/index.js 
 * 
 * Values for key constants
 */ 

export const isDev = () =>  !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
console.log("Development machine", isDev());

// URL of backend system
export const API_URL = isDev() ? "http://localhost:8000" : "";

// URL of fetch system
export const FETCHAPI_URL = "https://viewplan.org/app/";

// Local URL of fetch system
export const FETCHAPI_LOCALURL = "http://localhost";

// Base url of tile server
export const TILESERVER_BASEURL = isDev() ? "http://localhost:8080" : "https://tiles.wewantwind.org";

// Base url of main website
export const DOMAIN_BASEURL = isDev() ? "http://localhost:8000" : ("https://dev.wewantwind.org");

// Base url of CKAN index downloader
export const CKAN_INDEX_DOWNLOADER = isDev() ? "http://127.0.0.1:5000" : "https://data.wewantwind.org";

// Default maxbounds 
export const DEFAULT_MAXBOUNDS = [
    [
        -11.856802770948485,
        48.921496099104246
    ],
    [
        3.5121541807384062, 
        61.11071211434002 
    ]
]

// Default centre
export const DEFAULT_CENTRE = [
    -3.429071942460162,
    55.281960919035086
]


// Project types
export const PROJECT_TYPES = {
    "stage-0": 
    {
        "description": "Application / appeal submitted",
        "colour": "orange",
        "layers": 
        [
            "Application Submitted",
            "Appeal Lodged"
        ]
    },
    "stage-1": 
    {
        "description": "Application revised",
        "colour": "gold",
        "layers":
        [
            "Revised"
        ]
    },
    "stage-2":
    {
        "description": "Permission denied / appeal withdrawn",
        "colour": "red",
        "layers":
        [
            "Application Refused",
            "Appeal Refused",
            "Appeal Withdrawn"
        ]
    },
    "stage-3":
    {
        "description": "Awaiting or under construction",
        "colour": "green",
        "layers": 
        [
            "Awaiting Construction",
            "Under Construction",
            "No Application Required"
        ]
    },
    "stage-4":
    {
        "description": "Operational",
        "colour": "blue",
        "layers":
        [
            "Operational",
        ]
    },
    "stage-5":
    {
        "description": "Decommissioned",
        "colour": "purple",
        "layers": 
        [
            "Decommissioned",
        ]
    },
    "stage-6":
    {
        "description": "Abandoned / withdrawn / permit expired",
        "colour": "grey",
        "layers": 
        [
            "Abandoned",
            "Application Withdrawn",
            "Planning Permission Expired"
        ]    
    }
};